import React from 'react';
import { Tooltip } from '../../Tooltip';
import { Header } from '../components/Header';
import { HeaderContent, ClickableHeaderContent, SortIndicator } from '../components/ColumnHeader';
import { getNextSortState, GetSortIcon } from '../utils';
/**
 * Default renderer for table header cells
 *
 * @param column Column configuration object
 * @returns Header cell instance
 */
export function renderHeader({ column, sortState, onChangeSort, }) {
    if (column.sortable && !sortState) {
        throw new Error(`Column '${column.id}' is configured to be sortable but the 'sortState' prop is missing.`);
    }
    if (column.hidden) {
        return null;
    }
    const headerProps = {
        key: column.id.toString(),
        id: `datatable-header-${column.id}`,
        role: 'columnheader',
        align: column.align,
        spacing: column.spacing,
        className: column.sortable ? 'sortable' : undefined,
    };
    // If defined, use custom renderer
    if (column.renderHeader) {
        return column.renderHeader(column, headerProps);
    }
    const handleClickSort = () => {
        if (!sortState) {
            console.log('DataGrid::renderHeader::handleClickSort - sortState is not defined');
            return;
        }
        const nextSortState = getNextSortState({ sortState, columnId: column.id });
        if (!onChangeSort) {
            console.log('DataGrid::renderHeader::handleClickSort - onChangeSort is not defined');
            return;
        }
        onChangeSort(nextSortState);
    };
    const ColumnHeaderContent = column.sortable ? ClickableHeaderContent : HeaderContent;
    const columnHeaderProps = column.sortable ? { onClick: handleClickSort } : {};
    return (React.createElement(Header, Object.assign({}, headerProps),
        React.createElement(Tooltip, { text: column.tooltip },
            React.createElement(ColumnHeaderContent, Object.assign({}, columnHeaderProps),
                column.icon && column.icon,
                column.title && React.createElement("span", null, column.title),
                column.sortable && (React.createElement(SortIndicator, null,
                    React.createElement(GetSortIcon, { sortState: sortState, columnId: column.id, size: 5 })))))));
}
//# sourceMappingURL=renderHeader.js.map